import { colors } from 'fitify-ui'
import { css, styled } from 'styled-components'

export const ChipVariantsConstants = ['green', 'yellow'] as const

export type StyledChipProps = {
  variant: (typeof ChipVariantsConstants)[number]
}

export const StyledChip = styled.span<StyledChipProps>`
  width: max-content;
  padding: 4px 6px;

  color: ${colors.Black};
  border-radius: 6px;
  text-align: center;

  ${(props) => {
    switch (true) {
      case props.variant === 'green':
        return css`
          background: ${colors.Green400};
          font-size: 12px;
          font-weight: 500;
          text-transform: uppercase;
        `
      case props.variant === 'yellow':
        return css`
          background: ${colors.Yellow300};
          font-size: 13px;
          font-weight: 500;
        `
      default:
        return null
    }
  }}
`
